// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6m2wT","btnContainer":"styles_btnContainer__1qHNL"};